import { features } from "@/mocks/doujin";

export default function Experience() {
  return (
    <section id="experience" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-24">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="text-sm font-medium tracking-wide text-secondary-600">阅读体验</span>
          <h2 className="font-heading mt-2 text-2xl leading-snug text-foreground-950 md:text-4xl">
            为不同阅读偏好
            <br />
            用心设计的体验
          </h2>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
            从分类整理到多端适配，我们把"找到好作品、看得舒服"放在第一位，让每一次浏览都轻松顺畅。
          </p>
          <div className="mt-6 rounded-2xl bg-background-100 p-5">
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-question-line text-lg text-primary-500" />
              想找特定类型的同人作品？
            </div>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              先看主题分类快速定位，再进热门推荐按口味筛选，漫画本、插画集、四格漫、条漫、短篇集、画集打包一应俱全。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-3">
          {features.map((f) => (
            <div
              key={f.title}
              className="group flex cursor-pointer flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={f.icon} />
              </span>
              <h3 className="font-heading mt-4 text-lg text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}